import { application } from "./application"

import FlashController from "./flash_controller"
import MessageSizeController from "./message_size_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import ReadReceiptsController from "./read_receipts_controller"
import RichTextEditorController from "./rich_text_editor_controller"
import SearchController from "./search_controller"

application.register("flash", FlashController)
application.register("message-size", MessageSizeController)
application.register("password-visibility", PasswordVisibilityController)
application.register("read-receipts", ReadReceiptsController)
application.register("rich-text-editor", RichTextEditorController)
application.register("search", SearchController)
